import React from 'react';
import { Link } from 'react-router-dom';
import { CheckOutlined } from '@ant-design/icons';
import type { AgentWidgetProps } from 'lib.components/src/components/AgentWidgets';
import { attendee_memory } from 'lib.shared/src/routes';
import './styles.scss';

/**
 * The concierge's receipt after an answer is saved: its line, then where the
 * answer went — "Added to Memory · <section>" — and the way to see it.
 */
const MemorySavedWidget: React.FC<AgentWidgetProps> = ({ meta, message }) => (
  <div className="memory-saved" data-test-id="memory-saved">
    <p>{message.message}</p>
    <p className="memory-saved__receipt">
      <CheckOutlined />
      <span>
        Added to Memory
        {typeof meta.section === 'string' && (
          <>
            {' · '}
            <b>{meta.section}</b>
          </>
        )}
      </span>
      <Link to={attendee_memory} className="memory-saved__open">
        Open Memory
      </Link>
    </p>
  </div>
);

export default MemorySavedWidget;
